export interface ProjectImage {id:string;file?:string;thumbnail_url?:string;image_url?:string;pole_id?:string;structure_id?:string;job_asset_id?:string;inspection_id?:string;project_id?:string}
export function projectImages(raw:unknown,project?:string):ProjectImage[]{
  if(!Array.isArray(raw))return [];
  const seen=new Set<string>();
  return raw.filter((v):v is ProjectImage=>{
    if(!v||typeof v!=='object'||typeof v.id!=='string'||!v.id||seen.has(v.id)||project&&v.project_id&&v.project_id!==project)return false;
    seen.add(v.id);return true;
  });
}
export function relatedImages(raw:unknown,props:Record<string,unknown>,objectId:string,project?:string):ProjectImage[]{
  if(!Array.isArray(raw))return [];
  const ids=new Set(Array.isArray(props.image_ids)?props.image_ids.map(String):[]);
  return projectImages(raw,project).filter((v):v is ProjectImage=>{
    if(!v||typeof v!=='object'||typeof v.id!=='string'||!v.id)return false;
    if(ids.has(v.id))return true;
    for(const key of ['pole_id','structure_id','job_asset_id','inspection_id'] as const)if(v[key]!=null&&props[key]!=null&&String(v[key])===String(props[key]))return true;
    return v.job_asset_id!=null&&String(v.job_asset_id)===objectId;
  });
}
